import { useActivitiesStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreActivitiesComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ensureExhaustive } from "@overrides/utilities";
import { RadioGroup } from "@tenant/ui";
import type { TFunction } from "i18next";
import defaultStyles from "./FilterRating.module.scss";

export type FilterRatingProps = {
  selectedRating: ActivityRatingValueEnum;
  onChange: (value: ActivityRatingValueEnum) => void;
};

export type ActivityRating = 1 | 2 | 3 | 4 | 5;

export enum ActivityRatingValueEnum {
  Any = "any",
  ThreePointFive = "threePointFive",
  Four = "four",
  FourPointFive = "fourPointFive",
}

export const toActivityRatingValue = (
  rating: ActivityRatingValueEnum
): number => {
  switch (rating) {
    case ActivityRatingValueEnum.ThreePointFive:
      return 3.5;
    case ActivityRatingValueEnum.Four:
      return 4;
    case ActivityRatingValueEnum.FourPointFive:
      return 4.5;
    case ActivityRatingValueEnum.Any:
      return 0;
    default:
      ensureExhaustive(rating);
  }
};

export const toTextRating = (
  value: ActivityRatingValueEnum,
  t: TFunction
): string => {
  switch (value) {
    case ActivityRatingValueEnum.ThreePointFive:
      return t(
        "core-activities.availabilityPage.filters.rating.threePointFive"
      );
    case ActivityRatingValueEnum.Four:
      return t("core-activities.availabilityPage.filters.rating.four");
    case ActivityRatingValueEnum.FourPointFive:
      return t("core-activities.availabilityPage.filters.rating.fourPointFive");
    case ActivityRatingValueEnum.Any:
      return t("core-activities.availabilityPage.filters.rating.any");
    default:
      ensureExhaustive(value);
  }
};

const ratings = [
  ActivityRatingValueEnum.Any,
  ActivityRatingValueEnum.FourPointFive,
  ActivityRatingValueEnum.Four,
  ActivityRatingValueEnum.ThreePointFive,
];

export const FilterTripAdvisorRating = ({
  selectedRating,
  onChange,
}: FilterRatingProps) => {
  const styles = useActivitiesStyles(
    CoreActivitiesComponent.FilterTripAdvisorRating,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreActivitiesComponent.FilterTripAdvisorRating
  );

  const { t } = useI18nContext();
  const options = ratings.map((rating) => ({
    label: <div className={cn("label")}> {toTextRating(rating, t)}</div>,
    value: rating,
  }));

  return (
    <div className={block}>
      <RadioGroup
        options={options}
        onSelectValue={onChange}
        selectedOption={selectedRating}
      />
    </div>
  );
};
